import React from 'react';
import AdminWrapper from '../../Components/Admin/AdminWrapper/AdminWrapper';

const Admin: React.FC = () => {
    return (
        <div>
            <AdminWrapper />
        </div>
    )
};

export default Admin;